import { createAsyncThunk, createSlice, PayloadAction } from "@reduxjs/toolkit";
import { getDjangoEndpoint } from "src/utils/apiEndpoints";
import axiosInstance from "src/store/features/auth/axiosCSRF";
import { getApiErrorMessage } from "src/types/api";
export interface ListLibraryParams {
    library_id: string;
    created_at: string;
    created_round: string[];
    library_name: string;
    s3_patch: string;
    workflow_name: string;
    workflow_type : string;
}

export interface iListLibraryState {
    group_name: string;
    isLoading: boolean;
    message: string | null;
    response: ListLibraryParams[]; 
}

const initialState: iListLibraryState = {
    group_name: "",
    isLoading: false,
    message: "",
    response: [],
};

// List Library API 호출
export const listLibraryAPI = createAsyncThunk<
    ListLibraryParams[], // 반환 타입
    { group_name: string }, // 파라미터 타입
    { rejectValue: string } // rejectValue 타입
>(
    "LIST_LIBRARY",
    async (params: { group_name: string }, { rejectWithValue }) => {
        try {
            const djangoEndpoint = getDjangoEndpoint();
            const pathParam = '/library/list/';
            
            const response = await axiosInstance.get(`${djangoEndpoint}${pathParam}?group_name=${params.group_name}`, {
                withCredentials: true,
            });
            
            // API 응답 데이터가 ListLibraryParams[] 형태인지 확인
            return response.data as ListLibraryParams[];
        } catch (error) {
            return rejectWithValue(getApiErrorMessage(error));
        }
    }
);

// List Library Slice
export const listLibrarySlice = createSlice({
    name: "listLibrary",
    initialState,
    reducers: {
        // 필요시 추가 reducer 함수들
        setGroupName: (state, action) => {
            state.group_name = action.payload;
        },
        clearResponse: (state) => {
            state.response = [];
            state.message = "";
        },
        removeLibraryFromList: (state, action: PayloadAction<string>) => {
            state.response = state.response.filter(
                (library) => library.library_name !== action.payload
            );
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(listLibraryAPI.pending, (state, action) => {
                state.isLoading = true;
                state.message = "";
                state.group_name = action.meta.arg.group_name; // group_name 저장
            })
            .addCase(listLibraryAPI.fulfilled, (state, action) => {
                state.isLoading = false;
                state.response = action.payload; // 이제 ListLibraryParams[] 타입
                state.message = null;
            })
            .addCase(listLibraryAPI.rejected, (state, action) => {
                state.isLoading = false;
                state.message = action.payload as string;
                state.response = [];
            });
    },
});

export const { setGroupName, clearResponse, removeLibraryFromList } = listLibrarySlice.actions;
export default listLibrarySlice.reducer;
